import AsyncForm from '../../form/js/async-form.component';

export default class LoginFormComponent extends AsyncForm {
    onSuccess(response) {
        if (response.ReturnUrl) {
            window.location.href = response.ReturnUrl;
        } else {
            window.location.reload();
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/auth-forms/js/login-form.component.js